angular.module('wbServices', ['rails', 'ngCookies'])
.config(['$httpProvider', function($httpProvider) {
  $httpProvider.interceptors.push('sessionHttpInterceptor')
}]).run(['$rootScope', '$location', '$window', 'analytics',
  function($rootScope, $location, $window, analytics) {
    $rootScope.$on('$routeChangeSuccess', function(e, c, p) {
      if (!p || c && c.redirectTo) return
        var path = '/app' + $location.url()
      $window.setTimeout(function() {
        if (analytics && analytics.page) {
          analytics.page(path, { url: $location.absUrl(), path });
        }
      }, 0)
    })
  }
])

var requireAll = function(r) { r.keys().forEach(r) }
requireAll(require.context('./', true, /\.(js|ts|coffee)$/))
